export default __webpack_public_path__ + "static/media/image.41037ad0.png";